/* @ngInject */
function ManageFoldersTabController ($scope, AdminService, UserService, ToastService, RepositoryService) {
  $scope.companyDesignerOptions = []
  $scope.designersPagination = {
    top: 10,
    skip: 0
  }

  const api = {
    _getCompanyDesignerOptions,
    _getFolderSegmentation
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._getFolderSegmentation($scope.folders[0].id)
    api._getCompanyDesignerOptions()
  }

  $scope.onChangeRestrictAccess = event => {
    const value = event?.detail?.value
    $scope.flags.restrictAccess = !!value

    $scope.form.selectedDesigners = $scope.flags.restrictAccess ? $scope.flags.designersToShow : []

    $scope.flags.hasSave = !$scope.flags.hasSameSegmentation && $scope.flags.restrictAccess
  }

  function _getCompanyDesignerOptions (search = '', firstLoad = false) {
    AdminService.getUsers($scope.designersPagination.top, $scope.designersPagination.skip, { role: ['DESIGNER'], active: true, search })
      .then(users => {
        const mappedUsers = users.d.results
          .map(user => {
            return {
              url: user.profileImageId ? UserService.getUserProfileImage(user.id) : null,
              value: user.id,
              label: user.name
            }
          })

        $scope.companyDesignerOptions = firstLoad ? mappedUsers : $scope.companyDesignerOptions.concat(mappedUsers)
        $scope.hasMoreDesignersToLoad = users.d.__count > $scope.companyDesignerOptions.length
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  function _getFolderSegmentation (folderId) {
    RepositoryService.getFolderSegmentation(folderId).then((folderSegmentation) => {
      $scope.form.selectedDesigners = folderSegmentation.map(item => {
        return { value: item.id, label: item.name }
      })

      if ($scope.form.selectedDesigners.length) {
        $scope.flags.restrictAccess = true
      }
    })
  }

  $scope.onSearchDesigners = event => {
    const search = event?.detail?.search || ''
    $scope.designersPagination.skip = 0

    api._getCompanyDesignerOptions(search, true)
  }

  $scope.onInfiniteLoadDesigners = event => {
    const search = event?.detail?.search || ''
    $scope.designersPagination.skip += $scope.designersPagination.top

    api._getCompanyDesignerOptions(search, false)
  }

  $scope.onChangeDesigners = event => {
    $scope.flags.hasSave = false
    const changedDesigners = event?.detail

    $scope.form.selectedDesigners = changedDesigners
  }
}

export { ManageFoldersTabController }
